import * as React from 'react';
import TextField from '@mui/material/TextField';
import { useEffect } from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import {useSelector} from "react-redux";
import WebService from "@util/webService";
import useAlert from "@hooks/useAlert";
import useSnackbar from "@hooks/useSnackbar";
import useIndicator from "@hooks/useIndicator";
import MyDialog from "@components/MyDialog";
import Button from "@mui/material/Button";
import MUITable from "@mui/material/Table";
import MyTableHead from "@components/MyTableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {Fragment, useRef, useState} from "react";
import FlatButton from "@components/FlatButton";
import TableBody from "@mui/material/TableBody";
import {Container, TablePagination, Typography} from "@mui/material";
import {tablePaginationClasses} from '@mui/material/TablePagination'
import TableFooter from "@mui/material/TableFooter";
import {useTheme} from "@mui/material/styles";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import {findCode, truncate} from "@util/helper";
import ManagerMessageSmsPartSend from "@pages/manager/manager-message-sms.part.send";
import ManagerMessagePartPost from './manager-message.part.post';
import ManagerMessageSmsPartView from './manager-message-sms.part.view';
import {generatePath, useParams} from "react-router-dom";
import Tab from "@mui/material/Tab"
import TabList from "@mui/lab/TabList"
import TabContext from "@mui/lab/TabContext"
import TabPanel from "@mui/lab/TabPanel"
import { FormControl, InputLabel, Input, FormHelperText, Alert, Select, MenuItem, } from "@mui/material"
import MyDialog2 from '@components/MyDialog2';
import MyDialog3 from '@components/MyDialog3';
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';
import { useLocation } from 'react-router-dom';
import ManagerMessagePartUser from './manager-message.part.user';
const dateFormat = 'YYYY-MM-DD HH:mm:ss'

const attdncCodes = ['TP02', 'TP03']
export default function ManagerMessageSmsPage() {
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const [openSnackbar, renderSnackbar] = useSnackbar();
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator();
  const {alert, renderAlert} = useAlert()
  const [dataList, set_dataList] = useState([])
  const [totalCount, set_totalCount] = useState(0)
  const dgHandler = useState(false)
  const dgHandler2 = useState(false)
  const dgHandler3 = useState(false)
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: 10 });
  const {more} = useParams()
  const [tabValue, set_tabValue] = useState('1')
  const location = useLocation()
  const curLocationRef = useRef(location)
  const loadedRef = useRef(false)
  const fields = [
    {field: 'id', placeholder: '',    type:'text', value: -1, visible: more && (more === 'more'), canSrch: false, selList:[]},
    {field: 'regTime', placeholder: '일시',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'topicName', placeholder: '토픽',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    // {field: 'topicCode', placeholder: '구분',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'sendNm', placeholder: '발신인',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'title', placeholder: '제목',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'goal', placeholder: '대상',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'recvCnt', placeholder: '수신가능',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'arriveCnt', placeholder: '도달',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    // {field: 'attchCnt', placeholder: '첨부',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'content', placeholder: '내용',    type:'text', value: '', visible: true, canSrch: false, selList:[]},
  ]
  const generalTopicCodeList = codes.filter(r => r.codeGroupId === 'SA27' && !attdncCodes.includes(r.code))
  const termsRef = useRef({
    topicCodes: generalTopicCodeList.map(r => r.code).toString()
  })
  const [topicValue, set_topicValue] = useState('T')
  const visibleColumns = fields.filter(col => col.visible);
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })
  const recordRef = useRef(defRecord)
  
  const handleChangePage = (event, newPage) => {
    set_pageInfo({ ...pageInfo, pageNum: newPage });
  };


  const handleChangeRowsPerPage = event => {
    const pageSize = parseInt(event.target.value, 10);
    set_pageInfo({ pageNum: 0, pageSize: pageSize });
  };

  const TablePaginationActions = props => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = event => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = event => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = event => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label='first page'>
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label='previous page'>
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='next page'>
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='last page'>
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };


  const handleTabChange = (event, newValue) => {
		set_tabValue(newValue)

    if(newValue === '1') {
      const topicCodeList = generalTopicCodeList.map(r => r.code)
      termsRef.current = {...termsRef.current, topicCodes: topicCodeList.toString()}
      set_pageInfo({...pageInfo, pageNum:0})
    }
    else if(newValue == '2') {
      const topicCodeList = attdncCodes
      termsRef.current = {...termsRef.current, topicCodes: topicCodeList.toString()}
      set_pageInfo({...pageInfo, pageNum:0})
    }
	}

  const fetchMessage = async () => {
    const url = `/sms/${schola.id}`
    const newTerms = {};

    Object.keys(termsRef.current).forEach(key => {
      if (termsRef.current[key]) {
        newTerms[key] = termsRef.current[key];
      }
    });
   
    console.log('newTerms =>', newTerms)
    const params = {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
      terms: JSON.stringify(newTerms)
    }
    openIndicator() 
    const resp = await WebService.get(url, params)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    return JSON.parse(resp.repMessage)
  }

  const onLoad = async() => {
    const data = await fetchMessage()
    console.log('data ==> ', JSON.stringify(data, 0, 2))
    if(!data) {
      return
    }

    const records = JSON.parse(data.records)
    const totalCount = data.totalCount

    set_totalCount(totalCount)
    records.forEach(r =>{
      r.topicName = findCode(codes, 'SA27', r.topicCode)?.name ?? ''
      r.attchCnt = r.attchList.length
    })
    set_dataList(records)
  }

  useEffect(() => {
    onLoad()
    loadedRef.current = true
  },[pageInfo])

  useEffect(() => {
    if(curLocationRef.current.key !== location.key) {
      set_pageInfo({ pageNum: 0, pageSize: 10 })
      curLocationRef.current = location
    }
  }, [location])
  
  const Body = () => {
    return(
      <div style={{ paddingTop: 0, marginTop:20}}>
        {
          tabValue === '1' ? (
            <div style={{display:'flex',justifyContent:'flex-start', alignItems:'flex-start',maxWidth:200, marginBottom:20}}>
              <FormControl fullWidth >
                <InputLabel id='topic' size='small' sx={{fontSize:'0.9em'}}>
                  토픽
                </InputLabel>
                <Select
                  labelId='topic'
                  label='토픽'
                  size='small'
                  sx={{fontSize:'0.9em'}}
                  value={topicValue}
                  onChange={(e) => {
                    console.log('e.target.value', e.target.value)
                    if(e.target.value === 'T') {
                        const topicCodeList = generalTopicCodeList.map(r => r.code)
                        termsRef.current = {...termsRef.current, topicCodes: topicCodeList.toString()}
                    }
                    else {
                      termsRef.current = {...termsRef.current, topicCodes: e.target.value}
                    }
                    set_topicValue(e.target.value)  
                    set_pageInfo({...pageInfo, pageNum:0})
                  }}>

                  <MenuItem value={'T'}>
                    전체
                  </MenuItem>
                  {generalTopicCodeList.map((s, index) => {
                    return (
                      <MenuItem key={index} value={s.code}>
                        {s.name}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </div>
          ) : null
        }
        <MUITable sx={{minWidth:1200, }}>
          <MyTableHead>
            <TableRow>
              {
                fields.map((col, index) => (
                  col.visible ? (
                    <TableCell key={index} align='center' style={{width: col.field == 'regTime' ? 200: null}}>
                      {col.placeholder}
                    </TableCell>
                  ) : null
                ))
              }

            </TableRow>
          </MyTableHead>
          <TableBody>
            {dataList.map((row, index) => {
              return (
                <Fragment key={index} >
                  <TableRow
                    onMouseEnter={() => {
                      recordRef.current = row
                    }}>
                    {fields.map((col, index2) => {
                      if (col.visible) {
                        return (
                          <TableCell key={index2} align='center' 
                            style={{
                              cursor: col.field === 'content' ? 'pointer' : 'auto'
                            }}
                            onClick={() => {
                              if(col.field === 'content') {
                                  console.log('recordRef.current =>', JSON.stringify(recordRef.current, 0, 2))
                                  dgHandler2[1](true)
                              }
                              else if(col.field === 'goal') {
                                  dgHandler3[1](true)
                              }
                            }} 
                          >
                            <Typography variant='body2' fontWeight={col.field === 'name' ? 'bold' : 'normal'}>
                              {
                                col.placeholder == 'content' ? (
                                   truncate(row[col.field], 30) 
                                ) : (
                                   truncate(row[col.field], 30) 
                                )
                              }
                            </Typography>
                          </TableCell>
                        )
                      }
                    })}

                  </TableRow>
                </Fragment>
              )
            })}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                sx={{
                  [`& .${tablePaginationClasses.spacer}`]: {
                    display: "none"
                  },
                  [`& .${tablePaginationClasses.toolbar}`]: {
                    justifyContent: "center"
                  }
                }} 
                // rowsPerPageOptions={[10, 20, { label: "All", value: -1 }]}
                rowsPerPageOptions={[10, 20, 50, 100]}
                colSpan={visibleColumns.length + 1}
                count={totalCount}
                rowsPerPage={pageInfo.pageSize}
                page={pageInfo.pageNum}
                SelectProps={{
                  inputProps: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                labelDisplayedRows={({ from, to, count }) => {
                  // return '' + from + '-' + to + ' 개 ' + count
                  return `${from} - ${to} of ${count}`
                }}
                labelRowsPerPage={"페이지당 갯수"}
              />
            </TableRow>
          </TableFooter>
        </MUITable>

      </div>

    )
  }
  return (
    <div >
      {dgHandler[0] ? (<ManagerMessagePartPost dialogHandler={dgHandler} msgType='sms' callback={onLoad}/> ): null}
      {
        dgHandler2[0] ? (
          <MyDialog3 title={recordRef.current.title} windowWidth='sm' dialogHandler={dgHandler2}
            component=<ManagerMessageSmsPartView record={recordRef.current} dialogHandler={dgHandler2} />  
          />
        ) : null
      }
      {
        dgHandler3[0] ? (
          <MyDialog3 title={'수신정보'} windowWidth='sm' dialogHandler={dgHandler3}
            component=<ManagerMessagePartUser record={recordRef.current} dialogHandler={dgHandler3} />  
          />
          
        ) : null
      }

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}>
        <div style={{ paddingRight: 10 }}>
          <h1>문자 메시지 관리 </h1>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "row", }}>
        <Button variant='contained' color='primary' size='small' sx={{ mr: 1 }} startIcon={<TextsmsOutlinedIcon/>}  onClick={() => dgHandler[1](true)}>
          문자 메시지 전송
        </Button>
      </div>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <Body  />
			</Box>
      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
    </div>
  );
}
